import React from "react";

import PaginationItem from "./PaginationItem";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { ThemedButton } from "@/premium/themedComponents";

interface Props {
  pageCount: number;
  pageRange?: number;
  selectedPage?: number;
  handleSelectPage: (index: number) => void;
}

const Pagination: React.FC<Props> = (props: Props): JSX.Element => {
  const { pageCount, pageRange = 6, selectedPage = 0, handleSelectPage } = props;

  let maxPagesToDisplay = pageRange;
  if (pageCount < pageRange) {
    maxPagesToDisplay = pageCount;
  }

  // Determine the starting page index to display
  const midpoint = Math.floor(maxPagesToDisplay / 2);
  let startingIndex = selectedPage - midpoint;
  if (selectedPage < midpoint) {
    startingIndex = 0;
  } else if (selectedPage >= pageCount - midpoint) {
    startingIndex = pageCount - maxPagesToDisplay;
  }

  const paginationItems = [...Array(maxPagesToDisplay)].map((_, i) => {
    const pageIndex = i + startingIndex;

    return (
      <PaginationItem
        key={`page-${pageIndex}`}
        isSelectedPage={selectedPage === pageIndex}
        pageIndex={pageIndex}
        handleSelectPage={handleSelectPage}
      />
    );
  });

  const navigateToLast = (): void => {
    handleSelectPage(pageCount - 1);
  };

  const navigateToNext = (): void => {
    if (selectedPage < pageCount - 1) {
      handleSelectPage(selectedPage + 1);
    }
  };
  const navigateToPrevious = (): void => {
    if (selectedPage > 0) {
      handleSelectPage(selectedPage - 1);
    }
  };

  const navigateToFirst = (): void => {
    handleSelectPage(0);
  };

  return (
    <Shelf spacing="small">
      <Shelf.Spacer />
      <ThemedButton appearance="secondary" icon="chevron-start" onClick={navigateToFirst} tabIndex={0}></ThemedButton>
      <ThemedButton appearance="secondary" icon="chevron-left" onClick={navigateToPrevious} tabIndex={1}></ThemedButton>
      {paginationItems}
      <ThemedButton icon="chevron-right" onClick={navigateToNext} tabIndex={0}></ThemedButton>
      <ThemedButton icon="chevron-end" onClick={navigateToLast} tabIndex={1}></ThemedButton>
      <Shelf.Spacer />
    </Shelf>
  );
};

export default Pagination;
